"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The main function rounds a given number to a specified number of decimal places.
 * @param {number} value - Number that you want to round to a specific number of decimal places.
 * @param {number} decimalPlaces - Parameter is the number of decimal places to round the `value` parameter to.
 * @returns a number.
 */
const main = (value, decimalPlaces) => {
    /* Variable to store multiplier which is in the power of 10 */
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.round(value * multiplier) / multiplier;
};
exports.default = main;
//# sourceMappingURL=roundOff.js.map